<template>
  <div>
    <div class="tabel-bar">
      <div class="tabel-bar-left">
        <el-button type="primary" :size="$store.state.buttonSize" @click="resourcePopup()"
          >新增资源</el-button
        >
      </div>
      <div class="tabel-bar-right">
        <el-tooltip effect="dark" content="刷新列表" placement="bottom">
          <span
            class="el-icon-refresh icon-hover refresh-btn"
            @click="debounceRefresh"
          ></span>
        </el-tooltip>
      </div>
    </div>
    <el-table
      :data="tableData"
      v-loading="loading"
      :default-expand-all="true"
      row-key="id"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="resourceName" label="资源名称"> </el-table-column>
      <el-table-column prop="resourceCode" label="资源编码"> </el-table-column>
      <el-table-column prop="orderNum" label="排序"> </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="resourcePopup(scope.row.id)"
            >编辑</el-button
          >
          <el-button type="text" @click="resourceDel(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 资源表单 -->
    <el-dialog  :close-on-click-modal="false" :title="title" :visible.sync="resourceAddFormVisible" center>
      <el-form
        :model="resourceAddForm"
        :size="$store.state.formSize"
        :rules="resourceAddFormRules"
        ref="refresourceAddForm"
        label-width="140px"
      >
        <el-form-item label="父菜单：" prop="parentId">
          <el-cascader
            style="width:100%"
            v-model="resourceAddForm.parentId"
            :options="pidData"
            :props="{ value: 'id', label: 'resourceName', checkStrictly: true }"
            @change="handleChangeParentId"></el-cascader>
        </el-form-item>
        <el-form-item label="资源名称：" prop="resourceName">
          <el-input
            v-model="resourceAddForm.resourceName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="路由地址：" prop="vuePath">
          <el-input
            v-model="resourceAddForm.vuePath"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="资源地址：" prop="resourceUrl">
          <el-input
            v-model="resourceAddForm.resourceUrl"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="component：" prop="component">
          <el-input
            v-model="resourceAddForm.component"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="路由icon：" prop="icon">
          <el-input
            v-model="resourceAddForm.icon"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否Frame：" prop="isFrame">
          <el-radio-group v-model="resourceAddForm.isFrame">
            <el-radio label="0">否</el-radio>
            <el-radio label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否系统：" prop="isSys">
          <el-radio-group v-model="resourceAddForm.isSys">
            <el-radio label="0">否</el-radio>
            <el-radio label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序：" prop="orderNum">
          <el-input
            v-model="resourceAddForm.orderNum"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="布局模板：" prop="layout">
          <el-input
            v-model="resourceAddForm.layout"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="资源编码：" prop="resourceCode">
          <el-input
            v-model="resourceAddForm.resourceCode"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="资源类型：" prop="resourceType">
          <el-radio-group v-model="resourceAddForm.resourceType">
            <el-radio label="0">目录</el-radio>
            <el-radio label="1">菜单</el-radio>
            <el-radio label="2">按钮</el-radio>
            <el-radio label="3">其它</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :size="$store.state.buttonSize" :disabled="isDisabled" @click="debounceSubmit">确 定</el-button>
        <el-button :size="$store.state.buttonSize" @click="resourceAddFormVisible = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce } from 'throttle-debounce'

import {
  postResourceEdit,
  putResourceAdd,
  getResourceDetail,
  deleteResourceDel,
  getResourceTree
} from '@/api/resource'

const createFormVals = () => ({
  // *路由component
  component: '',
  icon: '',
  // *0:否; 1:是  非frame为外部系统资源
  isFrame: '0',
  isSys: '0',
  orderNum: 0,
  // *父菜单
  parentId: null,
  // *资源编码
  resourceCode: '',
  // *模块
  resourceModule: 0,
  // *资源名称
  resourceName: '',
  // *资源类型:单选 0、目录；1、菜单；2、按钮;3、其它
  resourceType: '0',
  // *资源地址
  resourceUrl: '',
  // *vue路由path
  vuePath: '',
  // 布局模板
  layout: ''
})

export default {
  data() {
    return {
      pid: 0,
      currentID: null,
      isDisabled: false,
      resourceAddFormVisible: false,
      tableData: [],
      pidData: [],
      resourceAddForm: createFormVals(),
      resourceAddFormRules: {
        resourceName: [
          { required: true, message: '请输入资源名称', trigger: 'blur' }
        ],
        vuePath: [
          { required: true, message: '请输入路由地址', trigger: 'blur' }
        ],
        resourceUrl: [
          { required: true, message: '请输入资源地址', trigger: 'blur' }
        ],
        parentId: [
          { required: true, message: '请选择父菜单', trigger: 'blur' }
        ],
        component: [
          { required: true, message: '请输入component', trigger: 'blur' }
        ]
      },
      loading: true
    }
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  computed: {
    title() {
      return this.currentID ? '编辑资源' : '新增资源'
    }
  },
  created() {
    this.debounceSubmit = debounce(300, this.resourceSubmit)
    this.debounceRefresh = debounce(300, this.refresh)
  },
  methods: {
    // 选择父级ID
    handleChangeParentId(value) {
      console.log(value)
      if (value.length > 1) {
        this.resourceAddForm.parentId = value[value.length - 1]
      } else {
        this.resourceAddForm.parentId = value[0]
      }
    },
    // 删除资源
    resourceDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteResourceDel(id).then(res => {
            if (res.status === 1) {
              this.$message.success('删除资源成功')
              this.getResourceListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 新增/修改资源
    resourceSubmit() {
      this.$refs.refresourceAddForm.validate(valid => {
        if (!valid) return false
        const changeresource = this.currentID ? postResourceEdit : putResourceAdd
        changeresource({
          resourceName: this.resourceAddForm.resourceName,
          component: this.resourceAddForm.component,
          icon: this.resourceAddForm.icon,
          isFrame: this.resourceAddForm.isFrame,
          isSys: this.resourceAddForm.isSys,
          orderNum: this.resourceAddForm.orderNum,
          parentId: this.resourceAddForm.parentId,
          resourceCode: this.resourceAddForm.resourceCode,
          resourceModule: this.resourceAddForm.resourceModule,
          resourceType: this.resourceAddForm.resourceType,
          resourceUrl: this.resourceAddForm.resourceUrl,
          vuePath: this.resourceAddForm.vuePath,
          layout: this.resourceAddForm.layout,
          id: this.currentID || undefined
        }).then(res => {
          if (res.status === 1) {
            this.currentID ? this.$message.success('编辑资源成功') : this.$message.success('新增资源成功')
            this.resourceAddFormVisible = false
            this.getResourceListData()
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      })
    },
    // 打开资源表单
    resourcePopup(id) {
      const isAdd = !id
      this.resourceAddFormVisible = true

      if (isAdd) {
        this.$set(this, 'resourceAddForm', createFormVals())
        this.currentID = null
      } else {
        this.isDisabled = true
        this.currentID = id
        getResourceDetail(id).then(res => {
          console.log(res)
          if (res.status === 1) {
            this.resourceAddForm.resourceName = res.data.resourceName
            this.resourceAddForm.component = res.data.component
            this.resourceAddForm.icon = res.data.icon
            this.resourceAddForm.isFrame = res.data.isFrame + ''
            this.resourceAddForm.isSys = res.data.isSys + ''
            this.resourceAddForm.orderNum = res.data.orderNum
            this.resourceAddForm.parentId = res.data.parentId
            this.resourceAddForm.resourceCode = res.data.resourceCode
            this.resourceAddForm.resourceModule = res.data.resourceModule
            this.resourceAddForm.resourceType = res.data.resourceType + ''
            this.resourceAddForm.resourceUrl = res.data.resourceUrl
            this.resourceAddForm.vuePath = res.data.vuePath

            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 刷新数据表格
    refresh() {
      this.getResourceListData()
      this.$message.success('数据刷新成功')
    },
    // 获取资源列表
    getResourceListData() {
      this.loading = true
      getResourceTree().then(res => {
        if (res.status === 1) {
          console.log(res)
          this.tableData = res.data
          this.pidData = res.data.slice()
          this.pidData.unshift(
            {
              id: 0,
              component: null,
              icon: '',
              isFrame: 1,
              isSys: 0,
              parentId: 0,
              resourceCode: '/',
              resourceLevel: 1,
              resourceModule: null,
              resourceName: '顶级目录',
              resourceType: 0,
              resourceUrl: null,
              vuePath: '/'
            }
          )
          console.log(this.pidData)
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      })
    }
  },
  mounted() {
    this.getResourceListData()
  }
}
</script>
